/* istanbul ignore file */

export const FEATURE_FLAG_NAMES_CONSTANTS = {
    AuthReleaseMfaLoginFlow: 'auth_release_mfa_login_flow',
    ShowUrlHasChangedBanner: 'show_url_changed_banner',
} as const;

export type FeatureFlagName = typeof FEATURE_FLAG_NAMES_CONSTANTS[keyof typeof FEATURE_FLAG_NAMES_CONSTANTS];
